import { makeStyles, css } from '@conexasaude/conexa-hero'
import { IS_PRODUCTION } from '@/constants'

const clariZIndex = '10'
const clariContainerXPos = '10px'
const clariContainerYPos = '14px'
const clariHeaderHeight = '56px'
const clariBorderRadius = '0px 0px 0px 16px'

const useStyles = makeStyles({
  supportLink: theme => css`
    display: flex;
    justify-content: center;
    color: ${theme.colors.brand.primary[300]};
    cursor: pointer;
    margin-top: ${theme.spacing.xxs};
    @media (min-width: ${theme.grid.breakpoint.lg}) {
      margin-bottom: ${theme.spacing.xxs};
    }
    margin-left: 5px;
  `,

  customHeading: theme => css`
    width: 100%;
    height: 120px;
    background-color: ${theme.colors.brand.primary[400]};

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      height: 110px;
    }
  `,

  customLayoutWrapper: theme => css`
    position: relative;
    top: -120px;
    margin-bottom: -120px;

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      top: -110px;
      margin-bottom: -110px;
    }
  `,

  container: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: calc(100% - 162px);
    position: relative;
  `,

  title: theme => css`
    color: ${theme.colors.background.white};
    margin-bottom: ${theme.spacing.sm};
  `,

  timerCountdownWrapper: theme => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${theme.spacing.md};
  `,

  waitingConsultationText: (theme, props) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.xs};
    margin-top: ${props?.isEarly ? theme.spacing.lg : theme.spacing.sm};
    z-index: 4;

    p {
      text-align: center;
    }
  `,

  coloredText: theme => css`
    color: ${theme.colors.brand.primary[300]};
  `,

  subheadingText: theme => css`
    color: ${theme.colors.neutral[200]};
  `,

  actionsContainer: theme => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: ${theme.spacing.md} auto 0;
    z-index: 4;

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      max-width: 510px;
    }
  `,

  actionsButtonsWrapper: theme => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.sm};

    @media (min-width: ${theme.grid.breakpoint.sm}) {
      flex-direction: row;
      justify-content: center;
    }
  `,

  actionButtonWrapper: css`
    width: 100%;
    max-width: 248px;
  `,

  attachmentListWrapper: theme => css`
    margin-top: ${theme.spacing.sm};
  `,

  attachmentListTitle: theme => css`
    margin-bottom: ${theme.spacing.xxs};
  `,

  illustrationWrapper: (theme, props) => css`
    width: 292px;
    margin: 0 auto;

    @media (min-width: ${theme.grid.breakpoint.md}) {
      position: absolute;
      top: ${props?.isEarly ? '300px' : '400px'};
      right: 0;
    }
  `,

  clariHelp: theme => css`
    z-index: ${clariZIndex};
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    width: 176px;
    height: 44px;
    transform: rotate(-90deg) translateX(50%);
    transform-origin: right bottom;
    border-radius: ${theme.border.radius.lg} ${theme.border.radius.lg}
      ${theme.border.radius.none} ${theme.border.radius.none};
    border-color: ${theme.colors.brand.primary[200]};
    background-color: ${theme.colors.brand.primary[100]};
    color: ${theme.colors.brand.primary[400]};
    font-size: ${theme.fontSizes.md};
    font-weight: ${theme.fontWeights.bold};
    gap: ${theme.spacing.xxs};
    border: 0.5px;
    cursor: pointer;

    p {
      @media only screen and (max-height: ${theme.grid.breakpoint.md}) {
        display: none;
      }
    }

    @media only screen and (max-height: ${theme.grid.breakpoint.md}) {
      width: 44px;
      height: 44px;
    }
  `,

  clariContainer: css`
    z-index: ${clariZIndex};
    position: fixed;
    right: ${clariContainerXPos};
    bottom: ${clariContainerYPos};
  `,

  clariHeader: theme => css`
    display: flex;
    background: #1f2937;
    align-items: center;
    height: ${clariHeaderHeight};
    justify-content: space-between;
    border-radius: ${theme.border.radius.lg} ${theme.border.radius.lg}
      ${theme.border.radius.none} ${theme.border.radius.none};

    &[data-fullscreen='false'] {
      width: 340px;
    }
    &[data-fullscreen='true'] {
      width: 100%;
    }

    img {
      margin: ${theme.spacing.xs};
    }
  `,

  clariHeaderRightSide: css`
    margin: 18px;

    button {
      outline: none;
      border: none;
      background: none;
      cursor: pointer;
    }
  `,

  clariPage: css`
    height: min(580px, 70vh);
    width: 340px;
    border-radius: ${clariBorderRadius};
  `,

  clariPageMaximized: css`
    height: calc(
      min(100vh - ${IS_PRODUCTION ? 0 : 32}px - ${clariContainerYPos}, 636px) -
        ${clariHeaderHeight}
    );
    width: calc(min(100vw, 1193px) - ${clariContainerXPos} - 14px);
    border-radius: ${clariBorderRadius};
  `,
})

export { useStyles }
